import React, {useState, useEffect} from 'react';
import './Login.css';
import {Button} from '@material-ui/core';
import db from './firebase';

function Login({switchAcc, click}) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [noti, setNoti] = useState('')
    const login = (event) => {
        event.preventDefault()
        db.collection('users').where('email','==',email).
        get().then((snapshot)=>snapshot.docs.forEach((doc)=> {
            if(email === doc.data().email && password === doc.data().password) {
                localStorage.setItem('usermail', email)
                click();
                setLock('')
                setLlock('')
            } else {
            }
        }))
        setEmail('');
        setPassword('');
        count()
        setInterval(count, 4000)
    } 
    var cout = 0
    const [lock, setLock] = useState('')
    const [llock, setLlock] = useState('')
    function count() {
        if(cout <= 2){
            cout++
        }
        if(cout === 1){
            setLock(true)
            setLlock(false)
        } else if (cout === 2) {
            setLock(false)
            setLlock(true)
        } 
    }
    return (
        <div className="login">
            <img src="image/logo.png" onClick={click} />
            <h3>Memory</h3>
            <p className={`noti ${lock && "noti__h"}`} >Loading ...</p>
            <p className={`mes ${llock && "mes__h"}`} >Wrong Email or Password!</p>
            <form>
            <input type="email" value={email}
            onChange={event => setEmail(event.target.value)}
            placeholder="Email" /><br/>
            <input type="password" value={password}
            onChange={event => setPassword(event.target.value)}
            placeholder="Password" /><br/>
            <Button type="submit" 
            disabled={!email || !password}
            onClick={login}>Log In</Button>
            </form>
            <p onClick={switchAcc}>Create Account?</p>
        </div>
    )
}

export default Login

/*
const [userdata, setUserdata] = useState([]);
    useEffect(() => {
        db.collection('users').where("email","==","yeminhtwe3467uon@gmail.com").onSnapshot(
            (snapshot) => setUserdata(snapshot.docs.map((doc)=>({id:doc.id, data:doc.data()})))
    )
}, [])
*/